import { siteConfig } from './siteConfig'

const baseUrl = siteConfig.seo.baseUrl
const ORG_ID = siteConfig.seo.organizationId
const PERSON_ID = siteConfig.seo.founderPersonId
const WEBSITE_ID = siteConfig.seo.websiteId
const LOGO_URL = `${baseUrl}/images/logo-720.png`

export const siteStructuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': ['EducationalOrganization', 'LocalBusiness'],
      '@id': ORG_ID,
      name: siteConfig.brand.academyName,
      alternateName: 'Skillo',
      url: baseUrl,
      logo: LOGO_URL,
      image: LOGO_URL,
      description: siteConfig.brand.entityStatement,
      email: siteConfig.contact.email,
      telephone: `+${siteConfig.contact.phoneE164}`,
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: `+${siteConfig.contact.phoneE164}`,
        contactType: 'admissions counselling',
        availableLanguage: siteConfig.seo.language,
        areaServed: siteConfig.contact.addressCountry,
      },
      priceRange: `${siteConfig.pricing.range} BDT per live cohort course`,
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Tilagor',
        addressLocality: siteConfig.contact.addressLocality,
        addressRegion: siteConfig.contact.addressRegion,
        addressCountry: siteConfig.contact.addressCountry,
      },
      areaServed: [
        { '@type': 'Country', name: 'Bangladesh' },
        { '@type': 'Place', name: 'Worldwide (online cohorts)' },
      ],
      inLanguage: siteConfig.seo.language,
      founder: { '@id': PERSON_ID },
      employee: { '@id': PERSON_ID },
      knowsAbout: [
        'AI agent engineering',
        'AI Agent Building',
        'n8n automation',
        'LangChain',
        'LangGraph',
        'Full-stack web development with AI',
        'Practical digital skills and portfolio building',
        'Basic Computer and English for Tech',
        'React Native mobile development',
        'UI/UX design with Figma',
        'Graphic design with AI tools',
        'SEO and AEO/GEO content strategy',
        'Digital marketing and Meta Ads',
      ],
      sameAs: [
        siteConfig.social.founderWebsite,
        siteConfig.social.founderGithub,
        siteConfig.social.founderLinkedIn,
        siteConfig.social.founderX,
        siteConfig.social.founderYoutube,
      ],
    },
    {
      '@type': 'Person',
      '@id': PERSON_ID,
      name: 'Minhaj Sadik',
      url: siteConfig.social.founderWebsite,
      jobTitle: 'Founder & Lead Instructor',
      worksFor: { '@id': ORG_ID },
      sameAs: [
        siteConfig.social.founderGithub,
        siteConfig.social.founderLinkedIn,
        siteConfig.social.founderX,
        siteConfig.social.founderYoutube,
      ],
    },
    {
      '@type': 'WebSite',
      '@id': WEBSITE_ID,
      url: baseUrl,
      name: siteConfig.brand.academyName,
      publisher: { '@id': ORG_ID },
      inLanguage: ['en', 'bn'],
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${baseUrl}/courses?q={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
  ],
}
